import { render, staticRenderFns } from "./dataGrid.vue?vue&type=template&id=0444acfc"
import script from "./dataGrid.vue?vue&type=script&lang=js"
export * from "./dataGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports